// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__24GEj","right":"Footer_right__3VD3t","buttons":"Footer_buttons__2rOaf"};